import React, { useState, useEffect } from 'react'
import Layout2 from "@/components/Layout/Layout2";
import { onlineOrderingLinks } from "@/components/lib/SidebarLinks";
import LeftBar2 from "@/components/Layout/LeftBar2";
import PathMap from '@/components/lib/PathMap';
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import FormInputField from "@/components/lib/from-input-field";
import { useForm } from "react-hook-form";
import { Form } from "@/components/ui/form";
import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell
} from '@/components/ui/table'
import { ButtonType } from '@/components/lib/Button'
import { PenLine, Trash2, Plus } from 'lucide-react'
import { Switch } from '@/components/ui/switch'
import { Label } from '@/components/ui/label'
import CreateItem from '@/components/dialog/menu-manage/common-dialog/create-item'
import { fetchAllFlatMenu } from "@/redux/slice/menu-manage-slice/menu-slice";
import { useDispatch } from 'react-redux';
import useAuth from '@/hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { createNewSmartQrCode } from '@/redux/slice/order-ordering-slice/smart-qr-codes-slice';
import { toast } from "react-hot-toast";
import { Loader2 } from 'lucide-react';



const createComboMealschema = z.object({
  name: z.string().min(1, "Name is required"),


  description: z.string().optional(),


  items: z.array(z.object({}).catchall(z.any())).optional(),

  price: z
    .preprocess(
      (val) =>
        val === null || val === undefined || val === "" ? null : Number(val),
      z.number({ invalid_type_error: "Price must be a number" }).nullable()
    )
    .optional(),

  discount_price: z
    .preprocess(
      (val) =>
        val === null || val === undefined || val === "" ? null : Number(val),
      z
        .number({ invalid_type_error: "Discount price must be a number" })
        .nullable()
    )
    .optional(),

  status: z.enum(["active", "inactive"]).default("active"),
});



const AddSmartQRCodeOrder = () => {

  const [itemVariants, setItemVariants] = useState([]);
  const [loading, setLoading] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [enableDiscount, setEnableDiscount] = useState(false)
  const [enableDayTime, setEnableDayTime] = useState(true)
  const dispatch = useDispatch();
  const { user } = useAuth()
  const navigate = useNavigate();

  const form = useForm({
    resolver: zodResolver(createComboMealschema),
    mode: "onChange",
    defaultValues: {
      name: "",
      description: "",
      items: [],
      price: null,
      discount_price: null,
      status: "active",
    },
  });


  function addToComboItemList(item){
    setItemVariants((prev)=>[...prev,item])
    form.setValue("items",[...form.getValues("items"),item])
    
  }

  function handleRemoveFromComboItemList(unique_id){
    
    const newComboItems = form.getValues("items").filter((item) => item?.unique_id !== unique_id);
    form.setValue("items", newComboItems);
    setItemVariants(newComboItems);  
  }

  const discount_price = form.watch('discount_price')
  const combo_days = form.watch('combo_days')

  console.log("all date", form.getValues())
  

  function handleSubmit(e){
    e?.preventDefault();
    const data = form.getValues();
    if (!data.name) {
      toast.error("Name is required");
      return;
    }

    setLoading(true);
    const formattedItems = itemVariants.map(item => ({
      item_id: item.item_id,
      item_type: item.item_type || "food",
      variant_id: item.variant_id || null,
      file_manager_id: item.file_manager_id || null,
      quantity: item.quantity || 1,
      price: item.out_price || item.price || 0,
      in_price: item.in_price || 0,
      out_price: item.out_price || 0
    }));

    const payload = {
      restaurant_id: user.restaurant_id,
      name: data.name,
      description: data.description || "",
      price: data.price || null,
      discount_price: data.discount_price || null,
      status: data.status,
      items: formattedItems
    };

    dispatch(createNewSmartQrCode(payload))
      .unwrap()
      .then(() => {
         toast.success("Smart QR Code created successfully");
         setLoading(false);
         navigate('/onlineordering/qr-code/smart-ordering');
      })
      .catch((err) => {
         toast.error(err || "Failed to create Smart QR Code");
         setLoading(false);
      });
  }

  function handleCancel(){

    form.reset()
    setItemVariants([])
    navigate(-1);
    
  }

  useEffect(() => {
    dispatch(fetchAllFlatMenu(user.restaurant_id));
  }, []);

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={onlineOrderingLinks} />}
    >
      <div className="container">
        <div className='flex justify-between items-center'>
          <PathMap 
            pageName={{ title: "SMART QR Code Order" }}
            paths={[
              // { name: "Home", path: "/" },
              // { name: "Online Ordering", path: "/online-ordering" },
              { name: "QR Code Ordering", path: "/onlineordering/qr-code/general" },
              { name: "SMART QR Code", path:"/onlineordering/qr-code/smart-ordering" }, 
              { name: "Create New SMART QR Code" },
            ]}
          />
        </div> 
        <div className=" w-[750px] mx-auto my-10 p-6 flex flex-col  gap-5  bg-color2">
            <div className='flex items-center gap-x-3'>
              <span className='text-xl text-color5'>Create New SMART QR Code</span>
            </div>
          <div className='flex flex-col gap-x-3'>
             <Form {...form}>
              <label className=' text-color5 pb-1'>Name</label>
              <FormInputField
                name="name"
                style="bg-cblack7"
                placeholder={"Enter item name"}
                form={form}
                type="text"
              />
            </Form>
          </div>
          <div className='flex justify-between items-center mb-4'>
            <h2 className='text-lg font-semibold text-color5'>Added Item List</h2>
            <ButtonType
              onClick={() => setOpenDialog(true)}
              className='bg-cgreen/70 text-cwhite flex flex-shrink-0'
            >
              <span className='flex items-center'>
                <Plus className='w-4 h-4 mr-1' /> Add New Item
              </span>
            </ButtonType>
          </div>
          <div className='relative'>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Item Name</TableHead>
                  <TableHead>Image</TableHead>
                  <TableHead>Quantity</TableHead>
                  <TableHead>Price</TableHead>
                  {/* <TableHead>In Price</TableHead>
                  <TableHead>Out Price</TableHead> */}
                  <TableHead className='text-right'>Action</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {itemVariants && itemVariants.length > 0 ? (
                  itemVariants.map((item, i) => (
                    <TableRow key={i}>
                      <TableCell>
                        {item?.item_name ||
                          item?.menu_item?.name ||
                          'Data not available'}
                      </TableCell>
                      <TableCell>
                        {item?.file_manager_url ? (
                          <img
                            src={item?.file_manager_url}
                            alt={item?.item_name}
                            className='w-12 h-12 rounded'
                          />
                        ) : (
                          'No Image'
                        )}
                      </TableCell>
                      <TableCell>{item?.quantity ?? 'N/A'}</TableCell>
                      <TableCell>
                        {item?.out_price !== undefined ? `£ ${item?.out_price}` : 'N/A'}
                      </TableCell>
                      {/* <TableCell>
                        {item?.in_price !== undefined
                          ? `£ ${item?.in_price}`
                          : 'N/A'}
                      </TableCell> */}
                      {/* <TableCell>
                        {item?.out_price !== undefined
                          ? `£ ${item?.out_price}`
                          : 'N/A'}
                      </TableCell> */}
                      <TableCell className='text-right'>
                        <span className='flex items-center justify-end gap-3'>
                          <Trash2
                            onClick={() => handleRemoveFromComboItemList(item?.unique_id)}
                            className='w-4 h-4 text-cred cursor-pointer'
                          />
                        </span>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} className='text-center'>
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>

            {/* Loading overlay */}
            {loading && (
              <div className='absolute inset-0 bg-black/40 flex justify-center items-center z-10'>
                <Loader2 className='animate-spin' />
              </div>
            )}
          </div>
          <div className='flex flex-col'>
             <Form {...form}>
              <label className=' text-color5 pb-1'>Price</label>
              <FormInputField
                name="price"
                style="bg-cblack7"
                placeholder={"Enter price"}
                form={form}
                type="number"
              />
            </Form>
          </div>
          <div className='flex flex-col'>
             <Form {...form}>
              <label className=' text-color5 pb-1'> Discount Price</label>
              <FormInputField
                name="discount_price"
                style="bg-cblack7"
                placeholder={"Enter discount price"}
                form={form}
                type="number"
              />
            </Form>
          </div>
          <div className='flex flex-col'>
            <Form {...form}>
              <FormInputField
                name="status"
                style="bg-cblack7 h-10"
                placeholder={"Select Status"}
                form={form}
                type="select"
                selectOption={[
                  { label: "Select Status", value: "", disabled: true },
                  { label: "Active", value: "active" },
                  { label: "Inactive", value: "inactive" },
                ]}
                label={"Status"}
              />
            </Form>
          </div>
          <div className='flex flex-col'>
             <Form {...form}>
              <label className=' text-color5 pb-1'> Description</label>
              <FormInputField
                name="description"
                style="bg-cblack7 text-color5"
                placeholder={"Enter Description"}
                form={form}
                type="textarea"
              />
            </Form>
          </div>
          <div className='flex justify-center gap-3'>
            <button onClick={handleCancel} className='bg-color8 text-color5 cursor-pointer w-full py-2 rounded-md'> Cancel</button>
            <button onClick={handleSubmit} className='bg-color7 text-color5 cursor-pointer w-full py-2 rounded-md'> Save</button>
          </div>
        </div>

        <CreateItem
          title={'Add Meal Item'}
          isOpen={openDialog}
          onClose={() => setOpenDialog(false)}
          onSuccess={item => addToComboItemList(item)}
        />

      </div>
    </Layout2>
  )
}

export default AddSmartQRCodeOrder ;